import { ComponentType } from "react"
import { Block, BlockProps, IconProps, useStyletron } from "@mezo-org/mezo-clay"

type OnboardingModalLinkedAccountIndicatorProps = BlockProps & {
  color: string
  Icon: ComponentType<IconProps>
}

export default function OnboardingModalLinkedAccountIndicator({
  color,
  Icon,
  ...props
}: OnboardingModalLinkedAccountIndicatorProps) {
  const [css, theme] = useStyletron()

  return (
    <Block
      className={css({
        width: theme.sizing.scale600,
        height: theme.sizing.scale600,
        background: color,
        borderRadius: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      })}
      {...props}
    >
      <Icon size={10} color={theme.colors.white} />
    </Block>
  )
}
